"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PetbarnBrandContext = void 0;
var _react = _interopRequireDefault(require("react"));
var _components = require("@PetSureAustralia/petsure-react-ui-library/distLib/components");
var _pinscomThemeContext = require("../../pinscomThemeContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PetbarnBrandContext = exports.PetbarnBrandContext = _objectSpread(_objectSpread({}, _pinscomThemeContext.pinscomThemeContext), {}, {
  brand: _objectSpread(_objectSpread({}, _pinscomThemeContext.pinscomThemeContext.brand), {}, {
    key: 'petbarnpica',
    broker: 'petbarnpica',
    styleSheet: 'petbarnpica',
    logos: [{
      key: 'petbarnLogo',
      imageUrl: 'https://petcdnstore.blob.core.windows.net/qt-assets/Prod/pinscom/Petbarn_logo.png',
      redirectUrl: '/'
    }, {
      key: 'pinscomLogo',
      imageUrl: 'https://petcdnstore.blob.core.windows.net/qt-assets/Prod/pinscom/pinscom_logo.png',
      redirectUrl: 'https://www.petinsurance.com.au/',
      target: '_blank',
      imageTitle: 'Get a pet insurance quote',
      imageTitleDescription: 'Provided by PetSure - Australia\'s leading Pet Insurance provider'
    }],
    supportPhoneNumber: '1300 618 412'
  }),
  layout: _objectSpread(_objectSpread({}, _pinscomThemeContext.pinscomThemeContext.layout), {}, {
    header: _objectSpread(_objectSpread({}, _pinscomThemeContext.pinscomThemeContext.layout.header), {}, {
      contactDetails: /*#__PURE__*/_react["default"].createElement("aside", {
        className: "contactDetails"
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: "https://petcdnstore.blob.core.windows.net/qt-assets/Prod/pinscom/icons/icon_petbarn_phone.png",
        alt: "phone icon for contact",
        className: "phoneIcon",
        height: 41,
        width: 20
      }), /*#__PURE__*/_react["default"].createElement("a", {
        href: "tel://1300618412"
      }, /*#__PURE__*/_react["default"].createElement("span", null, "Need help?"), /*#__PURE__*/_react["default"].createElement("span", null, "1300 618 412")))
    }),
    aside: {
      campaigns: [/*#__PURE__*/_react["default"].createElement(_components.CampaignHolder, {
        key: "PetbarnCampaign1",
        customCssClass: "PetbarnCampaign1",
        campaignImageDescription: "myPetPass logo",
        campaignBaseUrl: "https://petcdnstore.blob.core.windows.net/qt-assets/",
        campaignImageUrl: function campaignImageUrl(campaignBaseUrl) {
          return "".concat(campaignBaseUrl, "/pinscom/Petbarn_promo_tile_1.png");
        },
        __type: "CampaignHolder"
      }), /*#__PURE__*/_react["default"].createElement(_components.CampaignHolder, {
        key: "PetbarnCampaign2",
        customCssClass: "PetbarnCampaign2",
        campaignImageDescription: "myPetPass logo",
        campaignBaseUrl: "https://petcdnstore.blob.core.windows.net/qt-assets/",
        campaignImageUrl: function campaignImageUrl(campaignBaseUrl) {
          return "".concat(campaignBaseUrl, "/pinscom/Petbarn_promo_tile_2.png");
        },
        __type: "CampaignHolder"
      }), /*#__PURE__*/_react["default"].createElement(_components.CampaignHolder, {
        key: "PetbarnCampaign3",
        customCssClass: "PetbarnCampaign3",
        campaignImageDescription: "myPetPass logo",
        campaignBaseUrl: "https://petcdnstore.blob.core.windows.net/qt-assets/",
        campaignImageUrl: function campaignImageUrl(campaignBaseUrl) {
          return "".concat(campaignBaseUrl, "/pinscom/Petbarn_promo_tile_3.png");
        },
        __type: "CampaignHolder"
      }), /*#__PURE__*/_react["default"].createElement(_components.CampaignHolder, {
        key: "PetbarnCampaign5",
        customCssClass: "PetbarnCampaign5",
        campaignImageDescription: "GapOnly logo",
        campaignBaseUrl: "https://petcdnstore.blob.core.windows.net/qt-assets",
        campaignImageUrl: function campaignImageUrl(campaignBaseUrl) {
          return "".concat(campaignBaseUrl, "/Common/GapOnly_tile_232x200.png");
        },
        __type: "CampaignHolder"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        key: "PetbarnContactCampaign",
        className: "contactCard"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "callUsText"
      }, /*#__PURE__*/_react["default"].createElement("span", null, "Call us on", /*#__PURE__*/_react["default"].createElement("a", {
        href: "tel:1300618412"
      }, "1300 618 412")), /*#__PURE__*/_react["default"].createElement("img", {
        src: "https://petcdnstore.blob.core.windows.net/qt-assets/Prod/pinscom/icons/icon_footer_cat.svg",
        alt: "Monday to Friday (except public holidays) 8:00am to 8:00pm"
      })), /*#__PURE__*/_react["default"].createElement("span", {
        className: "disclaimerText"
      }, "Monday to Friday (except public holidays) 8:00am to 8:00pm"))]
    },
    footer: _objectSpread(_objectSpread({}, _pinscomThemeContext.pinscomThemeContext.layout.footer), {}, {
      footerSections: [{
        content: /*#__PURE__*/_react["default"].createElement("div", {
          className: "topFooterText"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "leftFrame"
        }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("img", {
          src: "https://petcdnstore.blob.core.windows.net/qt-assets/Prod/pinscom/Petbarn_logo.png",
          alt: "Petbarn footer logo",
          height: "64"
        }))), /*#__PURE__*/_react["default"].createElement("div", {
          className: "centerFrame"
        }, /*#__PURE__*/_react["default"].createElement("span", null, "Call us on", /*#__PURE__*/_react["default"].createElement("a", {
          target: "_blank",
          rel: "noreferrer",
          href: "tel:1300618412"
        }, "1300 618 412")), /*#__PURE__*/_react["default"].createElement("span", null, " Monday to Friday (except public holidays) "), /*#__PURE__*/_react["default"].createElement("span", null, " 8:00am to 8:00pm ")), /*#__PURE__*/_react["default"].createElement("div", {
          className: "rightFrame"
        }, /*#__PURE__*/_react["default"].createElement("img", {
          src: "https://petcdnstore.blob.core.windows.net/qt-assets/Prod/pinscom/icons/icon_lock.svg",
          alt: "Get a Pet insurance quote - Lock icon",
          width: "24"
        }), /*#__PURE__*/_react["default"].createElement("span", null, "Secured by", /*#__PURE__*/_react["default"].createElement("br", null), "256-bit SSL")))
      }, {
        content: /*#__PURE__*/_react["default"].createElement("div", {
          className: "bottomFooterText"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "leftFrame"
        }, /*#__PURE__*/_react["default"].createElement("p", null, "\xA9 Copyright 2021 by www.petinsurance.com.au. All rights reserved.")), /*#__PURE__*/_react["default"].createElement("div", {
          className: "centerFrame"
        }, /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("a", {
          href: "https://www.petinsurance.com.au/privacy-policy/",
          target: "_blank",
          rel: "noreferrer"
        }, "Privacy Policy"), "\xA0", /*#__PURE__*/_react["default"].createElement("span", null, "| View the\xA0", /*#__PURE__*/_react["default"].createElement("a", {
          href: "https://petinsurance.com.au/pds-forms-and-faqs/",
          target: "_blank",
          rel: "noreferrer"
        }, "PDS"), "\xA0and\xA0", /*#__PURE__*/_react["default"].createElement("a", {
          href: "https://petinsurance.com.au/tmds/",
          target: "_blank",
          rel: "noreferrer"
        }, "TMD")))))
      }],
      customDisclosure: _objectSpread(_objectSpread({}, _pinscomThemeContext.pinscomThemeContext.layout.footer.customDisclosure), {}, {
        hasGapOnly: true,
        hasPetScripts: false,
        myPetPass: {
          hasMyPetPass: false,
          eligibilityWordings: 'Available only to holders of active petinsurance.com.au policies'
        }
      })
    })
  })
});